import * as React from "react";
import type { SVGProps } from "react";
const SvgIconUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.38.68c-1.6.1-3.17.63-4.5 1.51-1.06.7-1.99 1.63-2.69 2.69-.57.86-1.02 1.9-1.26 2.88-.62 2.53-.16 5.2 1.26 7.36.7 1.06 1.63 1.99 2.69 2.69.86.57 1.9 1.02 2.88 1.26 2.53.62 5.2.16 7.36-1.26.9-.59 1.7-1.35 2.34-2.2.88-1.16 1.48-2.53 1.73-3.94.35-1.96.08-3.95-.78-5.72-.48-.99-1.04-1.78-1.81-2.55Q15 1.78 12.8 1.1C11.75.74 10.53.6 9.39.67m.01 1.43c-2.4.2-4.61 1.48-5.95 3.48Q2.4 7.13 2.14 9.04c-.05.39-.05 1.53 0 1.92.13.94.36 1.7.77 2.53.2.42.37.7.6 1.03.18.25.44.58.6.76l.12.12.08-.1c.17-.21.53-.6.74-.78q1.84-1.64 4.24-1.88c.3-.03 1.11-.03 1.42 0 1.42.14 2.75.68 3.86 1.56.39.3.84.75 1.12 1.1l.08.1.12-.12c.78-.84 1.43-2.05 1.76-3.26.07-.25.16-.73.2-1.06.03-.22.04-.4.04-.96 0-.75-.02-.94-.13-1.53-.14-.7-.34-1.29-.67-1.96-.4-.81-.86-1.46-1.5-2.1s-1.29-1.1-2.1-1.5-1.54-.62-2.46-.75c-.22-.03-.42-.04-.91-.05zm.11 1.9c-1.9.23-3.39 1.8-3.52 3.72-.1 1.45.58 2.82 1.78 3.63q.7.48 1.61.63c.28.05.98.05 1.26 0q.9-.15 1.61-.63c1.04-.7 1.7-1.83 1.78-3.07.1-1.45-.58-2.82-1.78-3.63-.8-.53-1.78-.77-2.74-.65m.29 1.41c-1.2.1-2.17 1-2.36 2.21-.08.5 0 1.04.24 1.52.4.83 1.2 1.38 2.12 1.45 1.37.1 2.56-.84 2.78-2.2.08-.5 0-1.05-.24-1.53-.47-.96-1.47-1.53-2.54-1.45m-.43 8.65c-.73.08-1.33.26-2 .6-.36.17-.63.34-.95.58-.43.32-1.14 1.06-1.09 1.12l.3.22q1.33.87 2.85 1.17c.59.11.78.13 1.53.13s.94-.02 1.53-.13c.82-.16 1.64-.47 2.38-.88l.77-.5c.05-.07-.66-.8-1.08-1.13-.35-.25-.6-.41-1.01-.6-.7-.35-1.28-.52-2.05-.59-.27-.03-.9-.02-1.18.01"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconUser;
